/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddModelsToOTADto } from '../models/AddModelsToOTADto';
import type { ApkUploadComplete } from '../models/ApkUploadComplete';
import type { ClientVersionDto } from '../models/ClientVersionDto';
import type { DeviceModelMajorApkDto } from '../models/DeviceModelMajorApkDto';
import type { EntityModelResponseContainerClientVersionDto } from '../models/EntityModelResponseContainerClientVersionDto';
import type { EntityModelResponseContainerDeviceModelMajorApkDto } from '../models/EntityModelResponseContainerDeviceModelMajorApkDto';
import type { EntityModelResponseContainerListDeviceModelMajorApkDto } from '../models/EntityModelResponseContainerListDeviceModelMajorApkDto';
import type { EntityModelResponseContainerUploadInfoDto } from '../models/EntityModelResponseContainerUploadInfoDto';
import type { PagedModelEntityModelDeviceModelMajorApkDto } from '../models/PagedModelEntityModelDeviceModelMajorApkDto';
import type { PagedResourcesAssemblerDeviceModelMajorApkDto } from '../models/PagedResourcesAssemblerDeviceModelMajorApkDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemDeviceOtaUpdateControllerService {
    /**
     * @returns PagedModelEntityModelDeviceModelMajorApkDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        client,
        model,
        major,
        startsWithFields,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerDeviceModelMajorApkDto,
        client?: string,
        model?: string,
        major?: number,
        startsWithFields?: Array<string>,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceModelMajorApkDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/ota-updates/apk-packages',
            query: {
                'client': client,
                'model': model,
                'major': major,
                'startsWithFields': startsWithFields,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerListDeviceModelMajorApkDto OK
     * @throws ApiError
     */
    public static addNewDevicesToVersion({
        requestBody,
    }: {
        requestBody: AddModelsToOTADto,
    }): CancelablePromise<EntityModelResponseContainerListDeviceModelMajorApkDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/ota-updates/apk-packages/addNewDevicesToVersion',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns DeviceModelMajorApkDto OK
     * @throws ApiError
     */
    public static bulkUpdate({
        assembler,
        requestBody,
        client,
        model,
        major,
        startsWithFields,
    }: {
        assembler: PagedResourcesAssemblerDeviceModelMajorApkDto,
        requestBody: DeviceModelMajorApkDto,
        client?: string,
        model?: string,
        major?: number,
        startsWithFields?: Array<string>,
    }): CancelablePromise<DeviceModelMajorApkDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/ota-updates/apk-packages/bulkUpdate',
            query: {
                'client': client,
                'model': model,
                'major': major,
                'startsWithFields': startsWithFields,
                'assembler': assembler,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteModel({
        clientId,
        modelId,
    }: {
        clientId: string,
        modelId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/ota-updates/apk-packages/clients/{clientId}/models/{modelId}',
            path: {
                'clientId': clientId,
                'modelId': modelId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        clientId,
        modelId,
        minorId,
        majorId,
    }: {
        clientId: string,
        modelId: string,
        minorId: number,
        majorId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/ota-updates/apk-packages/clients/{clientId}/models/{modelId}/major/{majorId}/minor/{minorId}',
            path: {
                'clientId': clientId,
                'modelId': modelId,
                'minorId': minorId,
                'majorId': majorId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceModelMajorApkDto OK
     * @throws ApiError
     */
    public static read({
        clientId,
        modelId,
        majorId,
        minorId,
    }: {
        clientId: string,
        modelId: string,
        majorId: number,
        minorId: number,
    }): CancelablePromise<EntityModelResponseContainerDeviceModelMajorApkDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/ota-updates/apk-packages/clients/{clientId}/models/{modelId}/major/{majorId}/minor/{minorId}',
            path: {
                'clientId': clientId,
                'modelId': modelId,
                'majorId': majorId,
                'minorId': minorId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceModelMajorApkDto OK
     * @throws ApiError
     */
    public static update({
        clientId,
        modelId,
        majorId,
        minorId,
        requestBody,
    }: {
        clientId: string,
        modelId: string,
        majorId: number,
        minorId: number,
        requestBody: DeviceModelMajorApkDto,
    }): CancelablePromise<EntityModelResponseContainerDeviceModelMajorApkDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/ota-updates/apk-packages/clients/{clientId}/models/{modelId}/major/{majorId}/minor/{minorId}',
            path: {
                'clientId': clientId,
                'modelId': modelId,
                'majorId': majorId,
                'minorId': minorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceModelMajorApkDto OK
     * @throws ApiError
     */
    public static uploadComplete({
        clientId,
        modelId,
        majorId,
        requestBody,
    }: {
        clientId: string,
        modelId: string,
        majorId: number,
        requestBody: ApkUploadComplete,
    }): CancelablePromise<EntityModelResponseContainerDeviceModelMajorApkDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/ota-updates/apk-packages/clients/{clientId}/models/{modelId}/major/{majorId}/upload-complete',
            path: {
                'clientId': clientId,
                'modelId': modelId,
                'majorId': majorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerUploadInfoDto OK
     * @throws ApiError
     */
    public static uploadInfo({
        clientId,
        modelId,
        majorId,
    }: {
        clientId: string,
        modelId: string,
        majorId: number,
    }): CancelablePromise<EntityModelResponseContainerUploadInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/ota-updates/apk-packages/clients/{clientId}/models/{modelId}/major/{majorId}/upload-info',
            path: {
                'clientId': clientId,
                'modelId': modelId,
                'majorId': majorId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerClientVersionDto OK
     * @throws ApiError
     */
    public static createClientVersion({
        requestBody,
    }: {
        requestBody: ClientVersionDto,
    }): CancelablePromise<EntityModelResponseContainerClientVersionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/ota-updates/apk-packages/createClientVersion',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
